export default {
  setString(key, value) {
    return localStorage.setItem(key, value)
  },
  getString(key) {
    return localStorage.getItem(key)
  },
  setObject(key, value) {
    return localStorage.setItem(key, JSON.stringify(value))
  },
  getObject(key) {
    return JSON.parse(localStorage.getItem(key))
  },
  removeItem(key) {
    return localStorage.removeItem(key)
  }
}